import { VibrateIcon } from './VibrateIcon';

/**
 * author: Google
 * id 68E64FD4-A020-4DEF-B2CB-5EA5BAA80E42
 * name vibrate
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vibrate.svg
 * tags
 */
export const VibrationIcon = VibrateIcon;
export default VibrationIcon